// @flow

// round number with the given number of decimal numbers
export const roundAndScale = (num: number = 0, scale: number = 2): number => {
	const myScale = scale.toFixed(0);
	return +(Math.round(num + "e+" + myScale) + "e-" + myScale);
};
